/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DistanceTreeNode } from './DistanceTreeNode';
import {
    DistanceTreeNodeFromJSON,
    DistanceTreeNodeFromJSONTyped,
    DistanceTreeNodeToJSON,
} from './DistanceTreeNode';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface SimilarityTreeResponse
 */
export interface SimilarityTreeResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof SimilarityTreeResponse
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {DistanceTreeNode}
     * @memberof SimilarityTreeResponse
     */
    payload?: DistanceTreeNode;
}

/**
 * Check if a given object implements the SimilarityTreeResponse interface.
 */
export function instanceOfSimilarityTreeResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SimilarityTreeResponseFromJSON(json: any): SimilarityTreeResponse {
    return SimilarityTreeResponseFromJSONTyped(json, false);
}

export function SimilarityTreeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarityTreeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : DistanceTreeNodeFromJSON(json['payload']),
    };
}

export function SimilarityTreeResponseToJSON(value?: SimilarityTreeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': DistanceTreeNodeToJSON(value.payload),
    };
}

